/**
 * Active project provider cache for global providers (AuthContext SSWS scoping).
 * AUTH0.IMPL.1-rev5
 */

const PROVIDER_KEY = "idwiz.activeProjectProviderId";
export const ACTIVE_PROJECT_PROVIDER_EVENT = "idwiz:activeProjectProvider";

/**
 * @param {string | null | undefined} providerId
 */
export function setActiveProjectProviderId(providerId) {
  try {
    if (providerId != null && String(providerId).trim() !== "") {
      sessionStorage.setItem(PROVIDER_KEY, String(providerId).trim().toLowerCase());
    } else {
      sessionStorage.removeItem(PROVIDER_KEY);
    }
    window.dispatchEvent(new Event(ACTIVE_PROJECT_PROVIDER_EVENT));
  } catch {
    /* ignore */
  }
}

/**
 * @returns {string | null}
 */
export function getActiveProjectProviderId() {
  try {
    const v = sessionStorage.getItem(PROVIDER_KEY);
    return v != null && String(v).trim() !== "" ? String(v).trim().toLowerCase() : null;
  } catch {
    return null;
  }
}

/**
 * @param {string | null | undefined} pathname
 * @returns {string | null}
 */
export function parseProjectIdFromPathname(pathname) {
  const m = /^\/project\/([^/]+)/.exec(String(pathname || ""));
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Okta SSWS validate/capabilities sync runs on home and Okta project routes only.
 *
 * @param {string | null | undefined} pathname
 * @param {string | null | undefined} activeProjectProviderId
 */
export function shouldRunOktaSswsSessionSync(pathname, activeProjectProviderId) {
  const projectId = parseProjectIdFromPathname(pathname);
  if (!projectId) return true;
  const provider = String(activeProjectProviderId || "").toLowerCase();
  if (provider === "okta") return true;
  if (provider === "entra" || provider === "auth0") return false;
  // Project route but provider not loaded yet — skip until ProjectContext sets cache.
  return false;
}
